import { useEffect, useState } from 'react';
import { LangProvider } from '@/hooks/useLang';
import Header from './components/Header';
import HeroSlider from './components/HeroSlider';
import ContactBanner from './components/ContactBanner';
import NewsSection from './components/NewsSection';
import CatchSection from './components/CatchSection';
import ProductsSection from './components/ProductsSection';
import { ConceptSection, AboutSection } from './components/LearnMoreSection';
import CasesSection from './components/CasesSection';
import Footer from './components/Footer';

function HomeContent() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 400);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Header />
      <HeroSlider />
      <ContactBanner />
      <NewsSection />
      <CatchSection />
      <ProductsSection />
      <ConceptSection />
      <CasesSection />
      <AboutSection />
      <Footer />

      {showTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="fixed bottom-8 right-6 z-50 bg-[#c0392b] text-white w-11 h-11 flex items-center justify-center hover:bg-[#a93226] transition-colors cursor-pointer"
          aria-label="Back to top"
        >
          <i className="ri-arrow-up-line text-lg"></i>
        </button>
      )}
    </div>
  );
}

export default function HomePage() {
  return (
    <LangProvider>
      <HomeContent />
    </LangProvider>
  );
}
